var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageCatalog',{attrs:{"init-catalog-scope":_vm.catalogScope,"init-catalog-state":_vm.catalogState,"init-page":_vm.page,"init-per-page":_vm.perPage,"init-products":_vm.products,"is-search":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }